"use client";

import React from "react";

import Image from "next/image";
import DecorationLine from "@/components/global/ui/DecorationLine";
import Chip from "@/components/global/ui/Chip";

import {cn} from "@/lib/utils";
import {PortableText} from "@portabletext/react";
import {richTextComponent} from "@/sanity/sanityPortableText";
import {CTACornerButton} from "@/shadcn/ui/corner-button";

import {PageCommunitySchema} from "@/sanity/pages/PageCommunityTemplate";

export default function DiscordSection({
  data,
  className
}: {
  data: PageCommunitySchema;
  className?: string;
}) {

  return (
    <section
      id="Discord"
      className={cn(
        "relative overflow-clip py-[12rem] lg:py-[22rem]",
        className
      )}
    >
      <DecorationLine
        className="top-0"
        orientation="vertical"
        position="left"
      />
      <DecorationLine
        className="top-0"
        orientation="vertical"
        position="right"
      />

      <div className="container relative">
        <div className="w-[min(187.75rem,100%)] mx-auto flex flex-col lg:flex-row items-center lg:items-start lg:justify-between gap-[4rem]">
          <div className="flex flex-col items-center lg:items-start w-[min(60rem,100%)] lg:sticky lg:top-[15rem]">
            <Chip
              image={data?.discordChip?.icon}
              text={data?.discordChip?.text}
            />

            {data?.discordText && (
              <div className="richtext lg:richtext-start w-[min(58.25rem,100%)]">
                <PortableText
                  value={data.discordText}
                  components={richTextComponent}
                />
              </div>
            )}

            {data?.discordCTA && (
              <CTACornerButton
                className="mt-[2rem]"
                data={data.discordCTA}
              />
            )}
          </div>

          {data?.discordItems && (
            <div className="flex-shrink-0 w-[min(115rem,100%)] grid grid-cols-1 md:grid-cols-2 gap-x-[3rem] gap-y-[5rem] lg:gap-y-[8rem]">
              {data.discordItems?.map((item, index) => (
                <div
                  key={index}
                  className="flex flex-col items-start"
                >
                  {item?.image && (
                    <Image
                      className="!w-full mb-[2rem] lg:mb-[2.5rem]"
                      src={item.image}
                      quality={95}
                      alt=""
                    />
                  )}

                  {item?.text && (
                    <div className="richtext richtext-start prose-strong:text-black prose-strong:font-normal">
                      <PortableText
                        value={item.text}
                        components={richTextComponent}
                      />
                    </div>
                  )}
                </div>
              ))}
            </div>
          )}
        </div>
      </div>
    </section>
  );
}
